var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{ref:_vm.clef,class:_vm.cssClass,attrs:{"disabled":_vm.isDisabled,"required":_vm.required,"id":_vm.clef,"label":_vm.text,"value":_vm.value,"loading":_vm.loading,"autocomplete":"address","rules":_vm.rules.adresse},on:{"change":_vm.updateFromManualEntry}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }